import { cva } from "class-variance-authority";
import clsx from "clsx";
import type { ComponentPropsWithoutRef } from "react";
import { type GapToken, gapToClass } from "./gap";

interface RowProps extends ComponentPropsWithoutRef<"div"> {
  gap?: GapToken;
  align?: "start" | "center" | "end" | "stretch" | "baseline";
  justify?: "start" | "center" | "end" | "between" | "around";
  inline?: boolean;
}

const rowVariants = cva("", {
  variants: {
    align: {
      start: "items-start",
      center: "items-center",
      end: "items-end",
      stretch: "items-stretch",
      baseline: "items-baseline",
    },
    justify: {
      start: "justify-start",
      center: "justify-center",
      end: "justify-end",
      between: "justify-between",
      around: "justify-around",
    },
    inline: { true: "inline-flex", false: "flex" },
  },
  defaultVariants: { inline: false },
});

export function Row({ gap = "none", align, justify, inline, className, ...rest }: RowProps) {
  return <div className={clsx(rowVariants({ align, justify, inline }), gapToClass[gap], className)} {...rest} />;
}
